// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Sv44f","enabled":"D2Qbg","semi-rotate":"_1CYQu","semiRotate":"_1CYQu","inner-rotate":"lMM2r","innerRotate":"lMM2r","white":"_3bhOj","dark":"kQk_f"};